import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const rakebackBadges = createAsyncThunk(
  "rakebackBadges/rakebackBadges",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("rakeback/rakeback-badges-data", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const rakebackBadgesDataSlice = createSlice({
  name: "rakebackBadges",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rakebackBadges.pending, (state) => {
        state.loading = true;
      })
      .addCase(rakebackBadges.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(rakebackBadges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default rakebackBadgesDataSlice.reducer;
